import DATETIME_UTILITY from '../../utils/datetime';
import Translations from '../../components/Translations';
import React, {
    useEffect,
    useState,
} from 'react';
import {
    connect,
} from 'react-redux';
import {
    Grid,
    // Card,
    // Image,
    Header,
    // Icon,
    // Button,
} from 'semantic-ui-react';
import _ from 'lodash';

import {
    handleGetCoverages,
} from '../../actions';
import {checkoutSelection} from '../../api/selectiongql';
import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import ProductItem from '../../components/product/item';
import LoadTimer from '../../components/loadtimer';
import ModalHowToSelect from '../../components/modal/howtoselect';
import LeaveBarterItem from '../../components/leave_barter_item';
import ModalNegativeBalanceWarning from '../../components/modal/negativebalancewarning';
import ModalCompleteWarning from '../../components/modal/completewarning';
import PaymentSection from '../../components/payment/section';
import PaymentSummary from '../../components/payment/summary';
import {formatAmountWithCurrency} from '../../utils/currency';

const HomePage = (props) => {

    // console.log('props->', props);

    const [animationDone, setAnimationDone] = useState(false);
    const [isSelectionCheckedOut, setIsSelectionCheckedOut] = useState(false);

    useEffect(() => {
        (async() => {
            props.handleGetCoverages({}, (error) => {
                console.warn(error);
            });
        })();
    }, [props.config]);

    if (!props.isLoaded || animationDone === false) {
        return (
            <LoadTimer 
                animate={true} 
                countdown={true} 
                handleTimeup={() => {
                    setAnimationDone(true);
                }} 
            />
        );
    }

    const {
        config,
        products,
        coverages,
        leaveBarter,
    } = props;
    const {currencyMinorUnit} = config;
    const currency = config.showBaseCurrency ? config.currency : '';
    const allowPaymentChoice = config.allowPaymentChoice === true;

    const handleCheckout = async () => {
        const result = await checkoutSelection({token: config.token});
        if (result instanceof Error || result === false) throw new Error('Selection was not checked out.');
        return result;
    };

    // console.log('account->', config.account);
    // console.log('coverages->11', coverages);

    let totalSpent = HELPER_FUNCTION_UTILITY.calculateTotalSpent(coverages, leaveBarter);
    // console.log('totalSpent->', totalSpent);

    if (leaveBarter) {
        // console.log('leaveBarter.choice.price->', leaveBarter.choice.price);
        // totalSpent = totalSpent - leaveBarter.choice.price; // Removed for NWM
        // const amountToAdjust = 
    }



    const renderProducts = () => {
        return _.map(_.keysIn(products), (pKey) => {
            return (
                <ProductItem
                    key={pKey}
                    product={products[pKey]}
                    getAllCoverages={() => coverages}
                    coverages={HELPER_FUNCTION_UTILITY.extractCoveragesByProductKey(coverages, pKey)}
                    family={config.family}
                    currencyMinorUnit={currencyMinorUnit}
                    currency={currency}
                    disabled={isSelectionCheckedOut}
                />
            );
        });
    };

    // https://res.cloudinary.com/saiyean/image/upload/v1634051784/V3%20Logo/selection-banner-image.png

    return (
        <React.Fragment>
            <Grid container centered stackable columns={1} padded="vertically">
                <Grid.Column>
                    <div className="banner">
                        <div className="banner-header"><Translations text="selection.Select your benefits" backup={"Your benefit selection"} /></div>
                        <div className="banner-sub-header">
                            <Translations text="selection.closing_line1" backup="Open till {{dateTime}}" data={{ dateTime: DATETIME_UTILITY.parseDateTimeFromUTC(config.selection.endDate).format("DD MMM YYYY HH:mm") }} />
                        </div>
                        <p>
                            {DATETIME_UTILITY.getDaysToSpecificDateTime(config.selection.endDate, (count, unit, backup) => (
                                <Translations
                                    text={`selection.duration_${unit}`}
                                    backup={backup}
                                    data={{ count }}
                                    render={duration => (
                                        <Translations
                                            text="selection.selection_deadline"
                                            backup="Complete your selection in {{duration}}. You are allowed to make unlimited changes during this period."
                                            data={{ duration }}
                                        />
                                    )}
                                />
                            ))}
                        </p>
                        <p>
                            <b><Translations text="selection.flex_allocation" backup="Your flex allocation is {{amount}}" data={{ amount: formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas(config.account.balance, currencyMinorUnit), currency) }} /></b>
                        </p>
                    </div>
                    &nbsp;
                </Grid.Column>
            </Grid>
            
            <Grid container centered stackable columns={1} padded="vertically" style={{backgroundColor: "#EFEFEF", paddingBottom: allowPaymentChoice ? 230 : 120}}>

                {(leaveBarter) && (
                    <Grid.Column>
                        <LeaveBarterItem 
                            data={leaveBarter}
                            currencyMinorUnit={currencyMinorUnit}
                            currency={currency}
                            disabled={isSelectionCheckedOut}
                        />
                    </Grid.Column>
                )}

                <Grid.Column>
                    <Header><Translations text="selection.select_insurance" backup={"Select Insurance"} /><ModalHowToSelect />
                    </Header>
                </Grid.Column>
                <Grid.Column>
                    {renderProducts()}
                </Grid.Column>
                <Grid.Column>
                    {allowPaymentChoice
                        ? <PaymentSection
                            config={config}
                            total={totalSpent}
                            products={products}
                            coverages={coverages}
                            leaveBarter={leaveBarter}
                            onCheckout={handleCheckout}
                            onCheckoutCompleted={() => setIsSelectionCheckedOut(true)}
                            isSelectionCheckedOut={isSelectionCheckedOut}
                        />
                        : <ModalCompleteWarning
                            isAllowUserCheckout={config.isAllowUserCheckout}
                            onCheckout={handleCheckout}
                            onCheckoutCompleted={() => setIsSelectionCheckedOut(true)}
                        />}
                </Grid.Column>
                <Grid.Column>
                    &nbsp;
                </Grid.Column>
                <Grid.Column>
                    &nbsp;
                </Grid.Column>
            </Grid>
            {!allowPaymentChoice && <ModalNegativeBalanceWarning
                balanceAmount={config.account.balance - totalSpent}
            />}
            {!allowPaymentChoice && <PaymentSummary
                walletOnly
                total={totalSpent}
                startingBalance={config.account.balance}
                currencyMinorUnit={currencyMinorUnit}
                currency={currency}
                products={products}
                coverages={coverages}
                leaveBarter={leaveBarter}
            />}
        </React.Fragment>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        isLoaded: state.coverages.loaded,
        config: state.config,
        products: state.coverages.products,
        coverages: state.coverages.coverages,
        leaveBarter: state.config.leaveBarter,
    };
};

export default connect(mapStateToProps, {
    handleGetCoverages,
})(HomePage);
